import { axios, Response } from '../index'
import { Folder } from './get-folder-files-and-subfolders'

const getGroupFolders = (groupId: string): Response<Folder[]> => {
  return axios.get(`/v1/groups/${groupId}/folders`)
}

export default getGroupFolders
